import(/* webpackMode: "eager" */ "/chyronic/app/global-error.tsx")